import i18n from "@/plugins/i18n";
// import datasetType from "@/datasets/schoolType";
export default {
  browse: {
    table: {
      headers: [
        {
          text: i18n.t("model.prop.no"),
          value: "index",
          sortable: false,
          filterable: false,
        },
        {
          text: "Institution",
          value: "Institution",
        },
      ],
    },
  },
  read: {
    tabs: [
      {
        key: "Info",
        label: i18n.t("string.info"),
      },
    ],
    table: {
      headers: [
        {
          text: "Institution",
          value: "Institution",
        },
        {
          text: i18n.t("model.prop.created"),
          value: "timestampCreated",
          filterable: false,
        },
        {
          text: i18n.t("model.prop.lastUpdated"),
          value: "timestampUpdated",
          filterable: false,
        },
      ],
    },
  },
  add: {
    fields: [
      {
        type: "model",
        key: "institutionId",
        name: "Institution",
        model: "institution",
        optionText: "name",
        server: "sso",
        defaultValue: 1,
      },
    ],
    rules: {
      institutionId: [(v) => !!v || "Institution is required"],
    },
  },
  // addByType: {
  //   fields: [
  //     {
  //       type: "model",
  //       key: "state",
  //       name: "State",
  //       model: "state",
  //       optionText: "name",
  //       server: "sso",
  //       optionValue: "value",
  //     },
  //     {
  //       type: "select",
  //       key: "type",
  //       name: "Type",
  //       options: datasetType,
  //       optionText: "name",
  //       optionValue: "value",
  //       defaultValue: "public",
  //     },
  //   ],
  //   rules: {
  //     institutionId: [(v) => !!v || "Institution is required"],
  //   },
  // },
  edit: false,
  delete: true,
};
